import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { UserService } from '../../../Shared/Services/user.service';
import { EmitterService } from '../../../Shared/Services/emitter.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { ChartConfiguration } from 'chart.js';
@Component({
    selector: 'app-transactioncount',
    imports: [BaseChartDirective],
    templateUrl: './transactioncount.component.html',
    styleUrls: ['./transactioncount.component.scss']
})
export class TransactioncountComponent implements OnInit, OnDestroy {
  windowX!: number;
  windowY!: number;
  currentHover = "Total";
  windowsize!: number;
  slidecount!: number;
  JsonData!: any;
  Totalcount!: number;
  TotalcountIntial!:number;
  @ViewChild(BaseChartDirective)
  chart!: BaseChartDirective;
  private date: any = [];
  private trade: any[] = [];
  private order: any[] = [];
  private roe: any[] = [];
  private cat: any[] = [];
  private total: any[] = [];
  private routeData: any[] = [];
  private subscription!: Subscription;
  private interval:number = 0;
  
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 0,
    scaleValuePaddingY: 0,
    plugins: {
      colors: {
        enabled: true
      },
      datalabels: {
        display: false 
      },
      tooltips: {
        enabled: true,
        backgroundColor: 'Black',
        textColor: 'black',
        opacity: 1
      },
    },
    scales: {
      y: {
        // scaleLabel:{ display: true, labelString: 'Exception Count'},
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 5,
          // Create Numberic notation labels
          callback: function (value: any, index: any, values: any) {
            if(value){
            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + ' K';
            }
            if (value >= 1000000) {
              value = value / 1000000 + ' M';
            }
          }
            return value;
          }
        
        }
      },
      x: {
        //categoryPercentage: 0.8,
        //barPercentage: 0.5,
        scrollbar: {
          enabled: true
        }
      }
    },
  };

  public barChartLabels: string[] = this.date;
  public barChartType: string = 'bar';
  //public barChartLegend: boolean = true;
  public chartColors: any[] = [
    { backgroundColor: "#0288D1" }];
  public chartData: any[] = [
    {
      label: 'Transaction',
      data: this.total,
      categoryPercentage: 0.8,
      barPercentage:0.5,
      backgroundColor: "#0288D1"
    }
  ];

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: this.chartData
  }
  private leftCounter: number = 0;
  private isRequestCompleted:boolean=true;

  constructor(
    private UrlsService: UrlsService,
    private UserService: UserService,
    private datePipe: DatePipe,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService) {
  }

  getData() {
    if(this.isRequestCompleted){
      this.isRequestCompleted = false;
    this.SharedHttpClientService.get(
      this.UrlsService.setAPIURl3(
        APIURL.MD_TransactionCount,
        this.UserService.getActiveMPID(),
        this.UserService.getDays() + this.interval,
        "TOTAL"))
      .subscribe((data) => {
        this.isRequestCompleted = true;
        this.JsonData = data;
        if (this.JsonData == null) {
          this.JsonData = [
            { date: "No-Data", order: 0, trade: 0, route: 0, roe: 0, cat: 0, total: 0 },
            { date: "No-Data", order: 0, trade: 0, route: 0, roe: 0, cat: 0, total: 0 },
            { date: "No-Data", order: 0, trade: 0, route: 0, roe: 0, cat: 0, total: 0 },
            { date: "No-Data", order: 0, trade: 0, route: 0, roe: 0, cat: 0, total: 0 },
            { date: "No-Data", order: 0, trade: 0, route: 0, roe: 0, cat: 0, total: 0 }];
          this.Totalcount = Object.keys(this.JsonData).length;
          this.TotalcountIntial = this.Totalcount;
        }
       else{
        let previousTotal = this.Totalcount;
        this.Totalcount = Object.keys(this.JsonData).length;
        this.TotalcountIntial = this.Totalcount;
        this.slidecount = 0;
        if (this.Totalcount <= 5) {
          this.windowsize = 0;
          for (let i = 0; i < this.Totalcount; i++) {
            this.date.push(this.datePipe.transform(this.JsonData[i].date, 'dd-MMM'));
            this.total[i] = this.JsonData[i].total;
            this.trade[i] = (this.JsonData[i].trade);
            this.order[i] = (this.JsonData[i].order);
            this.roe[i] = (this.JsonData[i].roe);
            this.cat[i] = (this.JsonData[i].cat);
            if (this.currentHover === "Total") {
              this.Total();
            } if (this.currentHover === "Roe") {
              this.Roe();
            } if (this.currentHover == "Order") {
              this.Order();
            } if (this.currentHover == "Trade") {
              this.Trade();
            } if (this.currentHover == "CAT") {
              this.CAT();
            } if (this.currentHover == "Route") {
              this.route();
            }
          }
        } else {
          this.windowsize = 5;
          if(this.leftCounter<6){
            this.windowY = this.Totalcount + this.slidecount;
            this.windowX = (this.windowY - this.windowsize);
            
          } else {
            this.windowX = this.windowX + (Object.keys(this.JsonData).length - previousTotal);
          this.windowY = this.windowX + 5;
          }
          this.sortData();
        }
      }
      });
  }
  }

  clickLeft() {
    this.slidecount = -1;
    this.leftCounter++;
    if ((this.leftCounter%15!=0) && this.windowX!=10) {
      this.windowY = this.windowY + this.slidecount;
      this.windowX = (this.windowY - this.windowsize);
      this.sortData();
    }
  }
  clickRight() {
    this.slidecount = 1;
    if (this.windowY <= this.TotalcountIntial && this.windowsize >= 5) {
      this.windowY = this.windowY + this.slidecount;
      this.windowX = (this.windowY - this.windowsize);
      this.Totalcount += 1;
      this.sortData();
    }
  }
  sortData() {
    if ((this.windowY < this.Totalcount || this.leftCounter == 0) && this.windowY > 0) {
      if((this.leftCounter != 0 && this.leftCounter%15 == 0) || this.windowX==10){
        this.interval += 30;
        this.leftCounter++;
        this.getData();
      }
      let length = this.date.length;
      this.date.splice(0, this.date.length);
      this.total.splice(0, this.total.length);
      this.trade.splice(0, this.trade.length);
      this.order.splice(0, this.order.length);
      this.roe.splice(0, this.roe.length);
      this.cat.splice(0, this.cat.length);
      this.routeData.splice(0, this.routeData.length);
      for (let i = this.windowX, t = 0; i < this.windowY; i++ , t++) {
        if(this.JsonData[i] != undefined){        
        this.date.push(this.datePipe.transform(this.JsonData[i].date, 'dd-MMM'));
        this.total[t] = this.JsonData[i].total;
        this.trade[t] = (this.JsonData[i].trade);
        this.order[t] = (this.JsonData[i].order);
        this.roe[t] = (this.JsonData[i].roe);
        this.cat[t] = (this.JsonData[i].cat);
        this.routeData[t] = (this.JsonData[i].route);
      }
      }
    } 

    if (this.currentHover === "Total") {
      this.Total();
    } 
    if (this.currentHover === "Roe") {
      this.Roe();
    } 
    if (this.currentHover === "Order") {
      this.Order();
    } 
    if (this.currentHover === "Trade") {
      this.Trade();
    } 
    if (this.currentHover === "CAT") {
      this.CAT();
    }
    if (this.currentHover === "Route") {
      this.route();
    }
  }
  ngOnInit() {
    this.getData();
    this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }
  ngOnChanges() {
    this.chart.chart?.update();
  }

  ngAfterViewInit() {
  }

  reloadData($event: any) {
    /* Catch User Action Log */
        this.UserService.logUserActivity("Applied Dashboard Exception Count Filter", "Dashboard", {
          'Text1': this.UserService.userFirstName + ' Applied Dashboard Exception Count Filter from Dashboard',
          'Text2': 'User Filter Parameters: ' + JSON.stringify({ optedExceptionCountCategory: $event, page: 'Dashboard' })
        });

    this.currentHover = $event;
    if ($event === "Total") {
      this.Total();
    }
    if ($event === "Roe") {
      this.Roe();
    }
    if ($event === "Order") {
      this.Order();
    } 
    if ($event === "Trade") {
      this.Trade();
    } 
    if ($event === "CAT") {
      this.CAT();
    }   
    if ($event === "Route") {
      this.route();
    }         
    this.chart.chart?.update();
  }
  Total() {
    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
      {
        label: 'Total Transactions',
        data: this.total,
        backgroundColor: "#0288d1",
        categoryPercentage: 0.8,
        barPercentage: 0.5,
      }
    ]
  };
    this.chartColors[0].backgroundColor = ['#e84351',
      '#4d86dc',
      '#f3af37', '#434a54',
      '#3ebf9b'];
  }
  
  Order() {
    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
      {
        label: 'Order Transactions',
        data: this.order,
        backgroundColor: "#0288D1",
        categoryPercentage: 0.8,
        barPercentage: 0.5,
      }
    ]};
  }
  Trade() {
    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
      {
        label: 'Trade Transactions',
        data: this.trade,
        backgroundColor: "#0288D1",
        categoryPercentage: 0.8,
        barPercentage: 0.5,
      }
    ]};

  }
  Roe() {
    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
      {
        label: ' Roe Transactions',
        data: this.roe,
        backgroundColor: "#0288D1",
        categoryPercentage: 0.8,
        barPercentage: 0.5,
      }
    ]};
  }
  CAT() {
    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
      {
        label: ' CAT Transactions',
        data: this.cat,
        backgroundColor: "#0288D1",
        categoryPercentage: 0.8,
        barPercentage: 0.5,
      }
    ]};
  }
  route() {
    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
      {
        label: 'Route Transactions',
        data: this.routeData,
        backgroundColor: "#0288D1",
        categoryPercentage: 0.8,
        barPercentage: 0.5,
      }
    ]};
  }
  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}